import React from "react";
import Batch from "../Batch";
const PendingBatches = () => {
    return <Batch status="pending" title="Class/batch" />;
};

export default PendingBatches;
